export default function WhatsAppButton() {
  const phoneNumber = '5551995670049';
  const message = encodeURIComponent('Olá! Gostaria de solicitar um orçamento para serviços condominiais.');

  const handleWhatsAppClick = () => {
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
  };

  return (
    <button
      onClick={handleWhatsAppClick}
      className="fixed bottom-6 left-6 w-16 h-16 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-2xl flex items-center justify-center transition-all duration-300 hover:scale-110 z-50 cursor-pointer"
      aria-label="Contato via WhatsApp"
    >
      <i className="ri-whatsapp-line text-3xl"></i>
    </button>
  );
}